/* eslint-disable import/no-anonymous-default-export */
import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
// import { composeWithDevTools } from "redux-devtools-extension";

// General store app
export default (rootReducer, rootSaga) => {
	/* ------------- Redux Configuration ------------- */
	const middleware = [];
	const enhancers = [];

	/* ------------- Saga Middleware ------------- */
	const sagaMiddleware = createSagaMiddleware();

	middleware.push(sagaMiddleware);

	/* ------------ Logger Middleware ------------- */
	// middleware.push(createLogger());

	/* ------------- Assemble Middleware ------------- */

	enhancers.push(applyMiddleware(...middleware));
	// enhancers.push(composeWithDevTools());

	/* ------------- AutoRehydrate Enhancer ------------- */

	// in dev mode, we'll create the store through Reactotron
	const store = createStore(rootReducer, compose(...enhancers));

	sagaMiddleware.run(rootSaga);

	return store;
};
